import { MitigatingAction } from "./MitigatingAction.model";
import { ClosureEvidence } from "./ClosureEvidence.model";

export class RiskEvent {
  id: number;
  name: string;
  description: string;
  actionsTaken: string;
  futureActions: string;

  cost: number;
  creator: number;
  estimatedLiability: number;
  riskId: number;
  mitigationId: number;
  status: number;
  closureAnalysis: string;

  createdAt: string;
  deletedAt: string;

  riskEventMitigations: MitigatingAction[];

  riskEventClosureEvidences: ClosureEvidence[];


}
